<div class="sidenav">
    <div class="sidenav-item logo">
        <img src="assets/images/logo400x400.png" alt="logo" class="policy-logo400white sidenav-item top">
    </div>
    <div class="sidenav-top-item">
        <div class="sidenav-item icon">
            <div class="icon-container">
                <mat-icon aria-hidden="false" fontIcon="home"></mat-icon>
            </div>
        </div>
        <div class="sidenav-item icon">
            <div class="icon-container">
                <mat-icon aria-hidden="false" fontIcon="computer"></mat-icon>
            </div>
        </div>
        <div class="sidenav-item icon">
            <div class="icon-container">
                <mat-icon aria-hidden="false" fontIcon="compare_arrows"></mat-icon>
            </div>
        </div>
        <div class="sidenav-item icon">
            <div class="icon-container">
                <mat-icon aria-hidden="false" fontIcon="show_chart"></mat-icon>
            </div>
        </div>
    </div>
    <div class="sidenav-bottom-item">
        <div class="sidenav-item icon">
            <div class="icon-container">
                <mat-icon aria-hidden="false" fontIcon="person"></mat-icon>
            </div>
        </div>
        <div class="sidenav-item icon">
            <div class="icon-container">
                <mat-icon aria-hidden="false" fontIcon="logout"></mat-icon>
            </div>
        </div>
    </div>
</div>